import { isEmpty, intersection } from 'lodash-es'
import { Children, cloneElement, isValidElement, ReactNode } from 'react'

import { NewObject } from './object'

export const passPropsToSingleChild = (child: ReactNode, props: NewObject) => {
  if (isValidElement(child)) {
    const childProps = child.props as NewObject
    const updatedProps = { ...props, ...childProps }

    const commonKeys = intersection(Object.keys(props), Object.keys(childProps))

    const differentValues = commonKeys.filter(
      key => props[key] !== childProps[key],
    )

    if (!isEmpty(differentValues)) {
      console.log(
        'Prop conflicts detected:',
        differentValues.map(
          key => `${key}: ${props[key]} (original) vs ${childProps[key]} (new)`,
        ),
      )
    }

    const newChild = cloneElement(child, updatedProps)

    return newChild
  }

  return child
}

export const passPropsToChildren = (children: ReactNode, props: NewObject) =>
  Children.map(children, child => passPropsToSingleChild(child, props))
